import { render, staticRenderFns } from "./TabPurchaseXMLPreview.view.vue?vue&type=template&id=742dffb7&"
import script from "./TabPurchaseXMLPreview.view.vue?vue&type=script&lang=js&"
export * from "./TabPurchaseXMLPreview.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742dffb7')) {
      api.createRecord('742dffb7', component.options)
    } else {
      api.reload('742dffb7', component.options)
    }
    module.hot.accept("./TabPurchaseXMLPreview.view.vue?vue&type=template&id=742dffb7&", function () {
      api.rerender('742dffb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/sign/TabPurchaseXMLPreview.view.vue"
export default component.exports